import { useCallback } from 'react';
import type { ActionHandlerType, OnActionArgs } from '../../../../context/ActionsProvider/context';
import { useGlobalAppStateStore } from '../../../../stores/app/GlobalAppStateStore';
import { createWalkthroughInstanceEventBus } from '../../../../types/walkthroughInstanceEventBus';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import type { CONTROL_STEP_METHODS } from './schema/controlStep';

type ControlStepParams = {
  walkthroughId?: string;
  method: keyof typeof CONTROL_STEP_METHODS;
};

export const useControlStep = () => {
  const interfaceId = useGlobalAppStateStore().hooks.record.useId();

  const controlStep: ActionHandlerType = useCallback(
    ({ action }: OnActionArgs) => {
      const { method } = action.payload as ControlStepParams;
      const walkthroughInstanceEventBus = createWalkthroughInstanceEventBus(interfaceId);

      switch (method) {
        case 'nextStep':
          walkthroughInstanceEventBus.publish('onControlStep', { method: 'next' });
          break;
        case 'previousStep':
          walkthroughInstanceEventBus.publish('onControlStep', { method: 'previous' });
          break;
        default:
          console.error(`Unknown method: ${method as string}`);
      }

      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [interfaceId],
  );

  return { controlStep };
};
